import { user as actions } from '../actions'

export const initialState = {
  id: null,
  networks: [],
  invitations: []
}

export const setUser = user => dispatch => {
  dispatch({
    type: actions.SET_USER,
    user
  })
}
